import { apiSlice } from "../Api/apiSlice";

export const assignmentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignments: builder.query({
      query: () => "/assignments",
    }),
    getAssignmentMark: builder.query({
      query: () => "/assignmentMark",
    }),
    addAssignmnetMark: builder.mutation({
      query: (formData) => ({
        url: "/assignmentMark",
        method: "POST",
        body: formData,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data: UpdatedAssignmentMark } = await queryFulfilled;

          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignmentMark",
              undefined,
              (draft) => {
                draft.push(UpdatedAssignmentMark);
              }
            )
          );
        } catch (err) {}
      },
    }),
  }),
});

export const {
  useGetAssignmentsQuery,
  useAddAssignmnetMarkMutation,
  useGetAssignmentMarkQuery,
} = assignmentApi;
